import { useAttachments } from '..'
import { DocumentAddIcon } from '@heroicons/react/outline'
import { useTw } from '../../../../../../../../utils/Styles'

export function AttachmentButton() {
  const tw = useTw()
  const { addAttachment } = useAttachments()
  return (
    <>
      <input
        type="file"
        className={tw`hidden`}
        id="compose-attachment-button"
        onChange={(e) => addAttachment(Array.from(e.target.files)[0])}
      />
      <label
        htmlFor="compose-attachment-button"
        className={tw`text-foreground flex items-center h-9 px-2 cursor-pointer`}
      >
        <DocumentAddIcon className={tw`w-6 h-6 text-current`} />
      </label>
    </>
  )
}
